<template>
  <div class="w-full h-full flex flex-col bg-gray-100 dark:bg-[#191919]">
    <ElConfigProvider :size="state.size" :z-index="state.zIndex" :locale="locale">
      <RouterView />
    </ElConfigProvider>
  </div>
</template>

<script setup lang="ts">
  import { reactive, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import zhTw from 'element-plus/es/locale/lang/zh-tw';
  import zhCn from 'element-plus/es/locale/lang/zh-cn';
  import en from 'element-plus/es/locale/lang/en';
  import es from 'element-plus/es/locale/lang/es';
  import pt from 'element-plus/es/locale/lang/pt';
  import ja from 'element-plus/es/locale/lang/ja';
  import ko from 'element-plus/es/locale/lang/ko';
  import fr from 'element-plus/es/locale/lang/fr';
  import de from 'element-plus/es/locale/lang/de';
  import ru from 'element-plus/es/locale/lang/ru';
  import id from 'element-plus/es/locale/lang/id';

  const { locale: i18nLocale } = useI18n();
  
  const locale = computed(() => {
    switch (i18nLocale.value) {
      case 'zh-TW': return zhTw;
      case 'zh-CN': return zhCn;
      case 'es': return es;
      case 'pt': return pt;
      case 'ja': return ja;
      case 'ko': return ko;
      case 'fr': return fr;
      case 'de': return de;
      case 'ru': return ru;
      case 'id': return id;
      default: return en;
    }
  });

  const state = reactive({
    zIndex: 3000,
    size: 'small' as const
  });
</script>
